module.exports = __webpack_public_path__ + "static/img/setting2.9888430.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/setting2.png
// module id = eGLO
// module chunks = 24